import { getI18nCookieData } from '../modules/i18n';
import { getMarketLabel } from '../modules/marketsData';
import type { JbInTextTeaser } from '../../../../storybook/src/components/jb-in-text-teaser/jb-in-text-teaser';

const cookieMarket = parseInt(getI18nCookieData().market, 10);
const cookieLanguage = parseInt(getI18nCookieData().language, 10);

function shouldBeRemoved(jbInTextTeaser: JbInTextTeaser&HTMLElement): boolean {
  const onlyMarkets = jbInTextTeaser.getAttribute('data-only-markets');
  const onlyMarketsArray = onlyMarkets?.split(',').map((market) => parseInt(market.trim(), 10));
  const isInOnlyMarkets = onlyMarketsArray?.some((market) => market === cookieMarket);
  return !isInOnlyMarkets;
}

async function setMarket(inTextTeaser: JbInTextTeaser&HTMLElement) {
  const marketLabel = await getMarketLabel(cookieMarket, cookieLanguage);
  inTextTeaser.market = {
    marketName: marketLabel,
  };
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('jb-in-text-teaser[data-only-markets]').forEach(async (inTextTeaser: JbInTextTeaser&HTMLElement) => {
    if (shouldBeRemoved(inTextTeaser)) {
      const parent = inTextTeaser.parentElement;
      if (parent && parent.tagName === 'JB-CONTENT-SPACING') {
        parent.remove();
      }
      inTextTeaser.remove();
      return;
    }

    setMarket(inTextTeaser).then();
  });
});
